
//==================BEGIN DEPENDENCIES========================

import 'reflect-metadata';
  
import 'jquery';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/utility/js/utils';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.auto.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/panzoom/jquery.panzoom';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/controller/js/controller';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-theme/plugins/enquire/js/enquire';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/truncate/js/truncate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/plugins/transplant/js/transplant';
  

//==================BEGIN VARIABLES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-theme/variables/js/photo-grid-variables';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/basic/lists/js/list';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/basic/inputs/js/inputs';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/basic/base/js/base';
  

//==================BEGIN COMPONENTS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/components/figure-viewer/js/figure-viewer-script';
  

//==================BEGIN WIDGETS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/widgets/shibboleth/js/shibboleth';
  
import IpRanges from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/widgets/ip-ranges/js/ip-ranges';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';
  

//==================BEGIN TEMPLATES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/gsl/node_modules/ui-theme/templates/advanced-search/js/advanced-search-page';
  

//==================BEGIN GROUPS========================

import './groups/_jcf';

import './groups/_jquery';

import tabsMain from './groups/_tabs';
const main = (UX) => {
    const $transplant = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="transplant"]')),
        $list = Array.prototype.slice.call(document.getElementsByClassName('expandable-list')),
        $figureViewer = Array.prototype.slice.call(document.querySelectorAll('figure:not(.holder), .figure:not(.holder),.colored-block,.component-container')),
        $customShibboleth = document.getElementById('learnMorePopup'),
        $ipRanges = document.querySelector('.ipRangesWidget'),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup'))

try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($transplant.length ) {
            UX.transplant.init($transplant);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($list.length ) {
            UX.list.init($list);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.fieldsCtrl.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($figureViewer.length ) {
            UX.figureViewer.init($figureViewer);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($customShibboleth ) {
            UX.customShibboleth.init($customShibboleth);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ipRanges ) {
            UX.ipRanges = new IpRanges($ipRanges).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length ) {
            UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
tabsMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

